export default __webpack_public_path__ + "static/media/Category_SQUARES.1b82a26d.jpg";